<template>
    <div>
        <div
            class="d-lg-flex align-items-center justify-content-between mb-4 gap-2"
        >
            <div class="justify-content-star d-flex">
                <small
                    >Selecciona los usuarios que se asignarán a la ruta:</small
                >
            </div>
            <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                <search-input-component
                    :search="search"
                    @onSearch="onFilterSearch"
                />
                <select
                    v-if="companies.length > 0"
                    class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                    v-model="selectedCompany"
                    @change="loadUsers"
                >
                    <option value="">Seleccione una empresa...</option>
                    <option
                        v-for="company of companies"
                        :key="company.id"
                        :value="company"
                    >
                        {{ company.client }}
                    </option>
                </select>
            </div>
        </div>

        <v-data-table
            v-show="!loadingTable"
            :headers="headersTabs"
            :items="users"
            item-key="name"
            :search="search"
            :page="page"
            :items-per-page="itemsPerPage"
            class="elevation-1 table text-center align-middle small"
            loading-text="Cargando..."
            mobile-breakpoint="0"
            :header-props="{
                sortIcon: 'fa-solid fa-sort-amount-desc',
            }"
            hide-default-footer
        >
            <template slot="no-data">
                <div>No hay datos disponibles.</div>
            </template>
            <template v-slot:item="row">
                <tr class="text-center">
                    <td>
                        <input
                            type="checkbox"
                            :value="row.item.id"
                            :checked="selectedUsers.includes(row.item.id)"
                            v-model="selectedUsers"
                        />
                    </td>
                    <td>{{ row.item.firstname }} {{ row.item.lastname }}</td>
                    <td>{{ row.item.email }}</td>
                    <td>{{ row.item.position }}</td>
                </tr>
            </template>
            <template v-slot:footer>
                <div class="text-center pt-2">
                    <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="6"
                        next-icon="fas fa-angle-right"
                        prev-icon="fas fa-angle-left"
                    />
                </div>
            </template>
        </v-data-table>

        <loading-component v-show="loadingTable" />

        <div class="col-12 text-end">
            <button
                class="btn bg-utel-v2-secondary text-primary sin-borde rounded-8 px-5"
                :disabled="isEnrollDisabled"
                @click="enrollUsers"
            >
                Inscribir usuarios
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DefaultRoutesAddUsers",
    props: {
        url_get_students: { type: String, required: true },
        url_get_companies: { type: String, required: true },
        info: { type: Object, required: true },
        empresa_elegida: { type: [String, Object], default: "" },
    },
    emits: ["changeStep"],
    data() {
        return {
            search: "",
            headersTabs: [
                { text: "#", value: "id", width: "10px" },
                { text: "Colaboradores", value: "firstname" },
                { text: "Email", value: "email" },
                { text: "Cargo", value: "position" },
            ],
            users: [],
            totalItems: 0,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            selectedCompany: "",
            companies: [],
            selectedUsers: [],
            loadingTable: true,
            searchTimeout: null,
        };
    },
    computed: {
        isEnrollDisabled() {
            return this.selectedUsers.length === 0;
        },
    },
    watch: {
        page: "loadUsers",
        itemsPerPage() {
            this.page = 1;
            this.loadUsers();
        },
    },
    async mounted() {
        await this.loadCompanies();

        const shouldLoadUsers =
            (this.companies.length > 0 && this.empresa_elegida) ||
            this.companies.length === 0;

        if (shouldLoadUsers) {
            this.selectedCompany = this.empresa_elegida || "";
            await this.loadUsers(true);
            this.selectedUsers = this.info.users || [];
        } else {
            this.loadingTable = false;
        }
    },
    methods: {
        async loadCompanies() {
            try {
                const { data } = await axios.get(this.url_get_companies);
                this.companies = data.companies;
            } catch (error) {
                console.error("Error al cargar empresas:", error);
            }
        },
        async loadUsers(keepSelection = false) {
            const url = this.getLoadUsersUrl();
            if (!url) {
                this.users = [];
                this.loadingTable = false;
                return;
            }

            this.loadingTable = true;

            try {
                const { data } = await axios.get(url, {
                    params: this.buildRequestParams(),
                });
                this.updateUsersData(data, keepSelection);
            } catch (error) {
                console.error("Error al cargar usuarios:", error);
            } finally {
                this.loadingTable = false;
            }
        },
        getLoadUsersUrl() {
            if (this.selectedCompany) return this.selectedCompany.users;
            if (this.companies.length > 0) return null;
            return this.url_get_students;
        },
        buildRequestParams() {
            const params = {
                onlyByClient: true,
                onlyClient: true,
                page: this.page,
                per_page: this.itemsPerPage,
            };
            if (this.search) params.search = this.search;
            return params;
        },
        updateUsersData(data, keepSelection) {
            this.users = data.data;
            this.totalItems = data.total;
            this.page = data.current_page;
            this.pageCount = data.last_page;
            if (!keepSelection) this.selectedUsers = [];
        },
        onFilterSearch(searchText) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.search = searchText;
                this.page = 1;
                this.loadUsers();
            }, 400);
        },
        enrollUsers() {
            this.$emit("changeStep", {
                step: 3,
                route: this.info.ruta,
                users: this.selectedUsers,
                company: this.selectedCompany,
            });
        },
    },
};
</script>
